<template>
  <div>
    <div v-if="blast.teacherReviewId">
      <p><strong>{{ blast.assignment.assignedBy }}'s</strong> review:</p>
      <div :class="['rating', {single: single}]">
        <p>Teacher Rating</p>
        <rubric-criteria :rubric="blast.assignment.rubrics" v-model="blast.teacherReview.ratings" />
      </div>
      <blockquote v-html="blast.teacherReview.review"></blockquote>
    </div>
    <div v-if="blast.peerReviewsReceived.length">
      <div class="average">
        <p>You've received <strong>{{ blast.peerReviewsReceived.length }} peer</strong> reviews from others:</p>
        <div :class="['rating', {single: single}]">
          <p>Average Rating</p>
          <rubric-criteria :rubric="blast.assignment.rubrics" v-model="blast.reviewSummary" />
        </div>
      </div>
      <peer-reviews :reviews="blast.peerReviewsReceived" display="received" />
    </div>
    <div v-else>
      You have not yet received any peer reviews. Check back later!
    </div>
  </div>
</template>

<script>

  export default {
    name: 'BlastReviewsReceived',
    props: {
      blast: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        single: this.blast.assignment.rubrics.criteria.length == 1
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  .rating.single {
    display:flex; align-items:center; line-height:0;
    p {
      flex:2; margin-bottom:0;
    }
  }

  .average {
    margin-bottom:3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/blast-reviews-received.vue